import styled from 'styled-components';
import { theme } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: ${theme.spacing.large}px;
  background-color: ${theme.colors.white};

  ${media.md`
    justify-content: center;
    padding-top: 0;
    background-color: ${theme.colors.clearNew};
  `};
`;

export const Content = styled.div`
  width: 100%;

  ${media.md`
    width: 500px;
  `};
`;

export const Logo = styled.img`
  align-self: start;
  margin-left: ${theme.spacing.large}px;
  margin-bottom: ${theme.spacing.large}px;

  ${media.md`
    margin-left: 0;
  `};
`;

export const Panel = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${theme.spacing.medium}px;
  background-color: ${theme.colors.white};

  ${media.md`
    padding: ${theme.spacing.xxxlarge}px ${theme.spacing.huge}px;
    border-radius: ${theme.radii.regular}px;
  `};
`;
